import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';
import Icon from './Icon';

export default class Row extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    rowClassName: PropTypes.string,
    rowButtonsClassName: PropTypes.string,
    rowButtons: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
      ])
    ),
    disabled: PropTypes.bool
  };

  renderButton = (props, index) => {
    if (props) {
      if (props.action) {
        const disabled = this.props.disabled || props.disabled;
        return (
          <Button
            bsStyle={props.className || 'secondary'}
            onClick={!disabled && props.action}
            disabled={disabled}
            key={index}>
            { props.icon ? <Icon iconType={props.icon} /> : null }
            { props.label }
          </Button>
        )
      } else {
        return props;
      }
    } else {
      return null;
    }
  };

  render() {
    let disabledStyle = {
      pointerEvents:'none',
      opacity:.5
    };
    const hasRowButtons = this.props.rowButtons && this.props.rowButtons.length;

    let defaultRowClass = 'col-12';
    if (hasRowButtons) {
      defaultRowClass = 'col-10';
    }
    let className = 'row';
    if (this.props.className) {
      className = `${className} ${this.props.className}`;
    }
    return (
      <div className={className}>
        <div className={this.props.rowClassName || defaultRowClass} style={this.props.disabled ? disabledStyle : null}>
          { this.props.children }
        </div>
        {
          hasRowButtons ?
            <div className={this.props.rowButtonsClassName || 'col-2'}>
              {
                this.props.rowButtons.map((rowButton, index) => this.renderButton(rowButton, index))
              }
            </div> :
            null
        }
      </div>
    );
  }
}
